import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHgv = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Ellipsen",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 566.93 343.68",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:#fadf18;}.cls-2{fill:#213834;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-2",
			d: "M566.93,171.84c0,94.9-126.91,171.84-283.46,171.84S0,266.74,0,171.84,126.91,0,283.47,0s283.46,76.93,283.46,171.84"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-1",
			points: "448.21 124.87 422.56 192.46 395.22 120.17 367.4 129.34 410.57 233.48 434.56 233.48 479.59 124.87 448.21 124.87"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M319.38,129.52c-2.58-1.5-5.33-2.86-8.19-4-5.85-2.38-11.43-3.58-16.57-3.58-12.07,0-22.64,2.41-31.41,7.17-8.75,4.76-15.54,11.52-20.13,20.13-4.62,8.62-6.96,18.73-6.96,30.06,0,17.41,5.2,31.39,15.43,41.56,10.24,10.18,24.41,15.34,42.11,15.34,8.9,0,17.38-2.34,25.2-6.94l.87-.52v11.56c0,7.25-2.92,13.11-8.69,17.44-5.71,4.28-13.41,6.53-22.88,6.68-5.9-.15-11.87-1-17.75-2.51-5.74-1.48-12.16-3.84-19.1-7.03l-8.85,19.83c5.45,3.46,13.1,6.34,22.75,8.6,9.91,2.32,17.88,3.49,23.69,3.49,18.52,0,33.48-4.03,44.45-12,10.91-7.92,16.44-19.46,16.44-34.27v-120.27l-30.19,9.39-.22-.13ZM319.73,202.9l-.24.18c-4.3,3.03-8.47,5.34-12.4,6.86-3.94,1.52-8.05,2.3-12.23,2.3-8.73,0-15.65-3.07-20.58-9.16-4.9-6.02-7.39-14.03-7.39-23.78s2.53-17.83,7.51-24.02c5-6.23,11.89-9.38,20.46-9.38,4.49,0,8.73.74,12.59,2.18,3.84,1.45,7.91,3.89,12.07,7.22l.22.18v47.42Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M179.1,121.45c-5.47,0-11.75,1.06-18.65,3.15-6.91,2.09-13.68,5.04-20.12,8.77l-.87.5v-62.29l-29.58,9.17v152.72l29.58-9.17v-66.39l.24-.17c5.73-3.92,11.04-7.1,15.8-9.44,4.82-2.37,10.04-3.56,15.5-3.56s9.69,1.98,12.72,5.88c3.01,3.86,4.53,9.31,4.53,16.19v66.65l29.82-9.16v-58.85c0-13.84-2.93-24.76-8.7-32.46-5.74-7.65-15.92-11.54-30.27-11.54"
		})
	]
});
export default SvgHgv;
